import React from 'react';
import FadeIn from '../common/FadeIn';
import termsImg from '../../assets/images/termsImg.png';

const TermsHeroSection = () => {
  return (
    <section className="w-full relative h-[380px] sm:h-[460px] md:h-[520px] flex items-end text-center overflow-hidden">
      <FadeIn className="absolute inset-0 w-full h-full">
        <img
          src={termsImg}
          alt="Terms & Conditions Header - SeaSalt Creative Studio"
          className="w-full h-full object-cover object-center"
          loading="eager"
          decoding="async"
          width="1920"
          height="520"
        />
        <div className="absolute inset-0 bg-black/45" />
      </FadeIn>

      <div className="container relative z-10 max-w-[900px] px-6 mb-12 sm:px-10 text-white">
        <FadeIn>
          <h1 className="font-saolDisplayItalic leading-[1.7] tracking-[0.05em] font-normal text-[31px] md:text-[36px]">
            TERMS & CONDITIONS
          </h1>
        </FadeIn>

        <FadeIn>
          <p className="font-PromenadeItalic italic md:text-[22px] text-[23px] leading-[33px] md:leading-[0px] pt-[16px]">
            Everything you need to know about working together.
          </p>
        </FadeIn>
      </div>
    </section>
  );
};

export default TermsHeroSection;
